import { usePlanMealConditions as useMealConditions } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/meal-conditions/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanMealConditions = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { includedMeals } = viewModel;

	return useMealConditions({
		includedMeals,
		onSetViewModel,
	});
};
